import { render, staticRenderFns } from "./com-partner.vue?vue&type=template&id=63d4e3cc&scoped=true&"
import script from "./com-partner.vue?vue&type=script&lang=js&"
export * from "./com-partner.vue?vue&type=script&lang=js&"
import style0 from "./com-partner.vue?vue&type=style&index=0&id=63d4e3cc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4e3cc",
  null
  
)

export default component.exports